import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Use the raw response from the http repository to create a Ad Stats Value Object.
 */
export class FromAdDetailsStatsRawDataToAdStatsValueObjectMapper extends Mapper {
  constructor({config, adStatsValueObjectFactory}) {
    super()

    this._config = config
    this._adStatsValueObjectFactory = adStatsValueObjectFactory
  }

  map = async ({stats = {}}) => {
    const {views = 0, favorites = 0} = stats

    return this._adStatsValueObjectFactory({
      favorites,
      views
    })
  }
}
